import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Grid } from '@chakra-ui/react';
import { modalIconStyle } from '../NavigationMenuMobile.style';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function NavigationItem(_ref) {
  var title = _ref.title,
    icon = _ref.icon;
  return _jsxs(Grid, _objectSpread(_objectSpread({}, navigationItemStyle), {}, {
    "data-testid": "navigationItem",
    children: [_jsx(Flex, {
      children: title
    }), _jsx(Box, _objectSpread(_objectSpread({}, modalIconStyle), {}, {
      children: icon
    }))]
  }));
}
var navigationItemStyle = {
  templateColumns: '1fr auto',
  justifyContent: 'center',
  _hover: {
    cursor: 'pointer'
  }
};